import { render, staticRenderFns } from "./select-dept-dialog.vue?vue&type=template&id=8eca3484&scoped=true"
import script from "./select-dept-dialog.vue?vue&type=script&lang=js"
export * from "./select-dept-dialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8eca3484",
  null
  
)

export default component.exports